import { Column, Table, VisibilityState, flexRender,
    getCoreRowModel,
    useReactTable,} from '@tanstack/react-table';
import beaconMasterResultType from "../model/BeaconMasterResultType";
import { HTMLProps, useEffect, useState, useMemo } from 'react';
import React from 'react';
import { Button, Col, Form, OverlayTrigger, Row, Tooltip} from 'react-bootstrap';
import axios from 'axios';
import ExcelJS from 'exceljs'; 
import Loading from './Loading';
import BeaconModel from '../model/BeaconModel';
import beaconResultType from '../model/beaconResultType';
import { log } from 'console';
import { get } from 'http';

type PropsType = {
  result: beaconMasterResultType[],
  bundle_ids: string[],
  apikey: string
}


const BeaconMasterResultCommonDevice = (props:PropsType) => {
  const [detected_gt, setDetcted_gt] = useState<string>("");
  const [detected_lt, setDetcted_lt] = useState<string>("");
  const [bundle_id_ios, setBundle_id_ios] = useState<string>("");
  const [bundle_id_and, setBundle_id_and] = useState<string>("");
  const [bundle_id_gate, setBundle_id_gate] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //const [deviceDetectedDay, setDeviceDetectedDay] = useState<boolean>(false);
  const [deviceDetectedDayType, setDeviceDetectedDayType] = useState<'today' | 'plus1' | 'plus2' | 'plus3' | 'plus4' | 'plus5'>('today');
  
  const beaconResults: BeaconModel[] = [];
  const [basebeaconIdArrays, setBaseBeaconIdArray] = useState<string[]>([]);
  const [basebeaconNameArrays, setBaseBeaconNameArray] = useState<string[]>([])
  const [subjectbeaconIdArrays, setSubjectBaseBeaconIdArray] = useState<string[]>([]);
  const [subjectbeaconNameArrays, setSubjectBaseBeaconNameArray] = useState<string[]>([]);

  const data: beaconMasterResultType[] = props.result;
  const [filterText, setFilterText] = useState<string>('');
  const filteredData: beaconMasterResultType[] = useMemo(() => {
    if (!filterText) return data;
    const tokens = filterText
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(Boolean);
    if (tokens.length === 0) return data;
    return data.filter(row => {
      for (const [, v] of Object.entries(row as any)) {
        if (v === null || v === undefined) continue;
        const t = typeof v;
        if (t === 'string' || t === 'number' || t === 'boolean') {
          const s = String(v).toLowerCase();
          if (tokens.some(token => s.includes(token))) {
            return false; // いずれかのトークンに部分一致したら除外
          }
        }
      }
      return true;
    });
  }, [data, filterText]);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({});
  const records1secMap: Map<string, Record<string, any>> = new Map();
  const [numberoflogs, setNumberOfLogs] = useState<string>("30");
  const [intervaloflogs, setIntervalOfLogs] = useState<string>("60");
  var apiUrl:string = "https://api.bc-loco.jp/api/beacon_logs";
  var beaconApiUrl = "https://api.bc-loco.jp/api/beacons"
  
  //本番
  var opensearchApiurl:string = "https://aggregate-log-api.bcw-mt.com:5001/api/getSpecifiedTimeUniqueDevice/"
  var opensearchApiurl2:string = "https://aggregate-log-api.bcw-mt.com:5001/api/getSpecifiedTimeAndDeviceIdUniqueDevice/"
  var opensearchApiurl3:string = "https://aggregate-log-api.bcw-mt.com:5001/api/getBeaconRankingDeviceUniuqe/"
  var opensearchApiurl4:string = "https://aggregate-log-api.bcw-mt.com:5001/api/getSameDayDeviceids/"
  
  //ローカル
  /*
  var opensearchApiurl:string = "http://localhost:5001/api/getSpecifiedTimeUniqueDevice/"
  var opensearchApiurl2:string = "http://localhost:5001/api/getSpecifiedTimeAndDeviceIdUniqueDevice/"
  var opensearchApiurl3:string = "http://localhost:5001/api/getBeaconRankingDeviceUniuqe/"
  var opensearchApiurl4:string = "http://localhost:5001/api/getSameDayDeviceids/"
*/
  var bundleIdArray : string[] = []
  var deviceIdArray : Object[] = []

  
  const commonDeviceIds: { DeviceID: string; Beacon: string; Detected: string }[] = [];  
  const columns = [
    {
      id: 'select',
      header: ({ table }) => (
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      ),
      cell: ({ row }) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    },
    { header: "no", accessorKey: "no" },
    { header: "id", accessorKey: "id" },
    { header: "name", accessorKey: "name" },
    { header: "local_name", accessorKey: "local_name" },
    { header: "uuid", accessorKey: "uuid" },
    { header: "major", accessorKey: "major" },
    { header: "minor", accessorKey: "minor" },
    { header: "action", accessorKey: "action" },
    { header: "tx_power", accessorKey: "tx_power" },
    { header: "battery", accessorKey: "battery" },
    { header: "module_id", accessorKey: "module_id" },
    { header: "manufacturer", accessorKey: "manufacturer" },
    { header: "model", accessorKey: "model" },
    { header: "note", accessorKey: "note" },
    { header: "x", accessorKey: "x" },
    { header: "y", accessorKey: "y" },
    { header: "h", accessorKey: "h" },
    { header: "enabled", accessorKey: "enabled" },
    { header: "created", accessorKey: "created" },
    { header: "updated", accessorKey: "updated" }
    
  ];
    
  const table = useReactTable({
    columns,
    data: filteredData,
    getRowId: (row) => String((row as any).id),
    state: {
      columnVisibility: columnVisibility,
    },
    getCoreRowModel: getCoreRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
  })

  const getBaseBeaconIdArray = (e :any) => {
      table.getSelectedRowModel().rows.forEach ((el) => {
          basebeaconIdArrays.push(el.original.id);
      });
      const selectedIds = table.getSelectedRowModel().rows.map((el) => el.original.id); // 選択されたIDを取得
      setBaseBeaconIdArray(selectedIds);

      table.getSelectedRowModel().rows.forEach ((el) => {
        basebeaconNameArrays.push(el.original.name);
      });
      const selectedNames = table.getSelectedRowModel().rows.map((el) => el.original.name); // 選択されたNameを取得
      setBaseBeaconNameArray(selectedNames)
  }

  const getSubjectBaseBeaconIdArray = (e :any) => {
      table.getSelectedRowModel().rows.forEach ((el) => {
          subjectbeaconIdArrays.push(el.original.id);
      });
      const selectedIds = table.getSelectedRowModel().rows.map((el) => el.original.id); // 選択されたIDを取得
      setSubjectBaseBeaconIdArray(selectedIds);

      table.getSelectedRowModel().rows.forEach ((el) => {
        subjectbeaconNameArrays.push(el.original.name);
      });
      const selectedNames = table.getSelectedRowModel().rows.map((el) => el.original.name); // 選択されたNameを取得
      setSubjectBaseBeaconNameArray(selectedNames)
  }
  
  //BasesビーコンのDeviceIDを取得
  const getSpecifiedTimeAndBeaconIdsUniqueDevice = async (e: any, csvflg: string) => {

    if (isNaN(Number(numberoflogs))) {
      alert("件数は数値で入力して下さい")
      setIsLoading(false);
      return
        
    } else if (numberoflogs.length <= 0) {
      alert("件数を入力して下さい")
      setIsLoading(false);
      return
    } else if (parseInt(numberoflogs) <= 0 || parseInt(numberoflogs) >= 1000) {
      alert("件数は1件以上から1000件以内に設定して下さい")
      setIsLoading(false);
      return
    }

    //APIのパラメータ作成
    if (basebeaconIdArrays.length <= 0) {
        alert("ビーコンが選択されていません。");
        return
    }

    if (subjectbeaconIdArrays.length <= 0) {
        alert("ビーコンが選択されていません。");
        return
    }

    var gte = new Date(detected_gt).getTime() / 1000.0;
    var lte = new Date(detected_lt).getTime() / 1000.0;
    console.log(gte);
    console.log(lte);

    if (isNaN(gte)) {
      alert("Detect_gtが入力されていません");
      return
    } else if (isNaN(lte)) {
      alert("Detect_ltが入力されていません");
      return
    }

    if (bundle_id_ios == "" && bundle_id_and == "" && bundle_id_gate == "") {
      alert("BundleIDが入力されていません");
      return
    } else {
      if (bundle_id_ios != "") {
        bundleIdArray.push(bundle_id_ios)
      }
      if (bundle_id_and != "") {
        bundleIdArray.push(bundle_id_and)
      }
      if (bundle_id_gate != "") {
        bundleIdArray.push(bundle_id_gate)
      }
    }

    //Opensearchから指定時間のユニークなDeviceIDを取得
    
    let ret = true;
    e.preventDefault();
    console.log("bundle_id_ios:" + bundle_id_ios);
    console.log("bundle_id_and:" + bundle_id_and);
    console.log("bundle_id_gate:" + bundle_id_gate);
        
    setIsLoading(true);

    await axios.post(opensearchApiurl4,
    {
        app_id: bundleIdArray,
        beacons: basebeaconIdArrays.concat(subjectbeaconIdArrays),
        a_beacons: basebeaconIdArrays,
        b_beacons: subjectbeaconIdArrays,
        gte: gte,
        lte :lte
    },
    {
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }
    })
    .then(async res => {
        console.log(res);
        if(res.status === 400) {
            alert("エラーが発生しました。")
            setIsLoading(false)
            return ret = false
        } 
        const items = JSON.parse(JSON.stringify(res.data.aggregations))
        for (const devid of items.by_devices.buckets) {
          //by_dayのbucketsの配列の要素数分deviceIdArrayに追加
          for (const day of devid.by_day.buckets) {
            if (day.doc_count > 0) {
                // deviceIdArrayにオブジェクトでDeviceIDとkey_as_stringを保存
              deviceIdArray.push({
                deviceId: devid['key'],
                day: day.key_as_string
              });
            }
          }

        }
        getBeaconLogForDeviceIDAndDetectedDay(e, deviceIdArray, csvflg)
        //setIsLoading(false)
        //getSpecifiedTimeAndDeviceIdsUniqueDevice(e, deviceIdArray, csvflg)
    })
    .catch(err => {
          alert("エラーが発生しました。" + err.message)
          ret = false
          setIsLoading(false)
        })
    return ret
  }

  //DeviceIdArrayを使用して、1件ずつビーコンA群とB群に接触しているを確認
  const getBeaconLogForDeviceIDAndDetectedDay = async (e: any, deviceIdArray: Object[], csvflg: string) => {
    let allBuckets: any[] = [];
    let ret = true;

    for (const deviceIdObj of deviceIdArray) {
      console.log(deviceIdObj["day"]);
      //APIのパラメータ作成
      const day = new Date(deviceIdObj["day"]); // 例: "2025-06-16"

      // 00:00:00
      const startOfDay = new Date(day);
      startOfDay.setHours(0, 0, 0, 0);
      const gte = Math.floor(startOfDay.getTime() / 1000);

      // 23:59:59
      const endOfDay = new Date(day);
      endOfDay.setHours(23, 59, 59, 999);
      const lte = Math.floor(endOfDay.getTime() / 1000);

      //console.log("gte:", gte);
      //console.log("lte:", lte);

      const deviceId_Array : string[] = []
      deviceId_Array.push(deviceIdObj["deviceId"]);

      e.preventDefault();
      setIsLoading(true);

      //B群でのビーコンログ存在チェック
      try {
        const res = await axios.post(opensearchApiurl2,  {
          app_id: bundleIdArray,
          beacons: subjectbeaconIdArrays,
          devices: deviceId_Array,
          gte,
          lte
       },
      {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
        }
      });
        if (res.status === 400) {
          alert("エラーが発生しました。")
          setIsLoading(false)
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.aggregations));
        //B群のビーコンログが確認出来た場合、A群の存在チェック
        if (items.by_devices && items.by_devices.buckets) {
          try {
            const res = await axios.post(opensearchApiurl2, {
                app_id: bundleIdArray,
                beacons: basebeaconIdArrays,
                devices: deviceId_Array,
                gte: gte,
                lte: lte
            },
            {
                headers: {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*"
                }
            });
                 
            if (res.status === 400) {
              alert("エラーが発生しました。")
              setIsLoading(false)
              return ret = false
            }
            const items = JSON.parse(JSON.stringify(res.data.aggregations));
            // A群のビーコンログが確認出来た場合、ユニークなDeviceIDを取得
            if (items.by_devices && items.by_devices.buckets) {
              allBuckets = allBuckets.concat(items.by_devices.buckets);
            }
          } catch (err) {
            alert("エラーが発生しました。" + (err as any).message)
            ret = false
            setIsLoading(false)
            return
          }
        }
      } catch (err) {
        alert("エラーが発生しました。" + (err as any).message)
        ret = false
        setIsLoading(false)
        return
      }
    }

    // まとめて処理
    createCommonDeviceIdData(allBuckets);

    if (csvflg == "devices") {
      createCommonDeviceIdCsv()
      setIsLoading(false)
    } else if (csvflg == "beacons") {
      getPastAndFutureDataByDevicesAnd1sec(e)
    } else if (csvflg == "ranking") {
      // ここにランキング処理を追加する場合は、必要なロジックを実装
      getSpecifiedTimeAndBeaconIdsUniqueDeviceForRanking()
      //setIsLoading(false);
    }
    return ret;
  }

  /*
  //BaseビーコンのDeviceIDが対象のビーコンに接触しているユニークなDeviceIDを取得
  const getSpecifiedTimeAndDeviceIdsUniqueDevice = async (e: any, devices: string[], csvflg: string) => {

    //APIのパラメータ作成
    var gte = new Date(detected_gt).getTime() / 1000.0;
    var lte = new Date(detected_lt).getTime() / 1000.0;
    console.log(gte);
    console.log(lte);

    if (isNaN(gte)) {
      alert("Detect_gtが入力されていません");
      setIsLoading(false)
      return
    } else if (isNaN(lte)) {
      alert("Detect_ltが入力されていません");
      setIsLoading(false)
      return
    }

    if (bundle_id_ios == "" && bundle_id_and == "" && bundle_id_gate == "") {
      alert("BundleIDが入力されていません");
      setIsLoading(false)
      return
    } else {
      if (bundle_id_ios != "") {
        bundleIdArray.push(bundle_id_ios)
      }
      if (bundle_id_and != "") {
        bundleIdArray.push(bundle_id_and)
      }
      if (bundle_id_gate != "") {
        bundleIdArray.push(bundle_id_gate)
      }
    }
    if (devices.length <= 0) {
      alert("ユニークなDeviceIDが取得できませんでした。時刻範囲を見直して下さい");
      setIsLoading(false)
      return
    }

    let ret = true;
    e.preventDefault();
    setIsLoading(true);

    // 100件ずつ分割してリクエスト
    const chunkSize = 100;
    let allBuckets: any[] = [];
    for (let i = 0; i < devices.length; i += chunkSize) {
      const chunk = devices.slice(i, i + chunkSize);
      try {
        const res = await axios.get(opensearchApiurl2, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          },
          params: {
            app_id: bundleIdArray,
            beacons: subjectbeaconIdArrays,
            devices: chunk,
            gte: gte,
            lte: lte
          }
        });
        if (res.status === 400) {
          alert("エラーが発生しました。")
          setIsLoading(false)
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.aggregations));
        if (items.by_devices && items.by_devices.buckets) {
          allBuckets = allBuckets.concat(items.by_devices.buckets);
        }
      } catch (err) {
        alert("エラーが発生しました。" + (err as any).message)
        ret = false
        setIsLoading(false)
        return
      }
    }

    // まとめて処理
    createCommonDeviceIdData(allBuckets);

    if (csvflg == "devices") {
      createCommonDeviceIdCsv()
      setIsLoading(false)
    } else if (csvflg == "beacons") {
      getPastAndFutureDataByDevicesAnd1sec(e)
    } else if (csvflg == "ranking") {
      // ここにランキング処理を追加する場合は、必要なロジックを実装
      getSpecifiedTimeAndBeaconIdsUniqueDeviceForRanking()
      //setIsLoading(false);
    }
    return ret;
  }
*/

  /***
   *  ユニークなDeviceID群を使用して、指定時間のビーコンの検出情報から検出数のランキングを取得
   */
  const getSpecifiedTimeAndBeaconIdsUniqueDeviceForRanking = async () => {
    const gte = new Date(detected_gt).getTime() / 1000.0;
    const lte = new Date(detected_lt).getTime() / 1000.0;
    const chunkSize = 200;
    let allItems: any[] = [];

    try {
      await getBeacons()
    } catch {
      alert("エラーが発生しました。")
      setIsLoading(false);
      return
    }

    // DeviceIDでユニーク化
    const seen = new Set<string>();
    const commonDeviceIdsUnique = commonDeviceIds.filter(item => {
      if (seen.has(item.DeviceID)) {
        return false;
      }
      seen.add(item.DeviceID);
      return true;
    });

    // 以降、commonDeviceIdsUniqueを使って処理
    for (let i = 0; i < commonDeviceIdsUnique.length; i += chunkSize) {
      const chunk = commonDeviceIdsUnique.slice(i, i + chunkSize);
      try {
        const res = await axios.post(opensearchApiurl3, {
          deviceids: chunk.map(item => item.DeviceID),
          gte: gte,
          lte: lte
        }, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        });
        if (res.status === 400) {
          alert("エラーが発生しました。")
          continue;
        }
        const items = JSON.parse(JSON.stringify(res.data.aggregations));
        allItems.push(items);
      } catch (err) {
        alert("エラーが発生しました。" + (err as any).message);
        continue;
      }
    }

    // allItemsに全てのリクエスト結果が配列で格納されています
    // ここから合算処理
    try {
      const merged: { [key: string]: number } = {};

      allItems.forEach(item => {
        if (item.unique_beacon_device_pairs && item.unique_beacon_device_pairs.value) {
          item.unique_beacon_device_pairs.value.forEach((value: { key: string, device_count: number }) => {
            //console.log(bucket.key);
            if (merged[value.key]) {
              merged[value.key] += value.device_count;
            } else {
              merged[value.key] = value.device_count;
            }
          });
        }
      });

      // 結果を配列で出力したい場合
      const mergedArray = Object.entries(merged).map(([key, doc_count]) => ({ key, doc_count }));
      mergedArray.sort((a, b) => b.doc_count - a.doc_count); // doc_countで降順ソート

      console.log(mergedArray);

      // テーブルの除外フィルタをランキング出力にも適用
      const tokens = (filterText || '')
        .split(',')
        .map(t => t.trim().toLowerCase())
        .filter(Boolean);

      let filteredMergedArray = mergedArray;
      if (tokens.length > 0) {
        filteredMergedArray = mergedArray.filter(({ key }) => {
          const name = (beaconIdToBeaconName(key) || '').toLowerCase();
          //const idLower = String(key).toLowerCase();
          // トークンのいずれかがビーコン名またはビーコンIDに部分一致すれば除外
          return !tokens.some(token => name.includes(token));
        });
      }

      // keyをBeaconNameに変換
      const csvData = filteredMergedArray.map(({ key, doc_count }, index) => ({
        index: index + 1,
        BeaconName: beaconIdToBeaconName(key),
        doc_count,
      }));

      // CSV出力
      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("BeaconRanking");
      const worksheet = workbook.getWorksheet("BeaconRanking");
      worksheet!.columns = [
        { header: "No", key: "index" },
        { header: "BeaconName", key: "BeaconName" },
        { header: "count", key: "doc_count" }
      ];
      csvData.forEach(row => worksheet!.addRow(row));

      const uint8Array = await workbook.csv.writeBuffer();
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      const blob = new Blob([bom, uint8Array], { type: 'application/octet-binary' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      setTimeout(() => {
        a.href = url;
        a.download = "BeaconRanking_" + getNowDate() + ".csv";
        a.click();
        a.remove();
      }, 1000);
    } catch (error) {
      console.error("Error processing ranking data:", error);
      alert("ランキングデータの処理中にエラーが発生しました。");
    }
    setIsLoading(false);
  }

  //２つのビーコン群を期間内に取得していたDeviceID
  const createCommonDeviceIdData = async (data: any) => {
    data.forEach((value: any) => {
        var devidDataTemp = {};
        devidDataTemp['deviceid'] = value['key'];
        devidDataTemp['Beaconid'] = beaconIdToBeaconName(value.beacon_detected_top.hits.hits[0]._source.beacon_id);
        devidDataTemp['Detected'] = unixdateformat(value.beacon_detected_top.hits.hits[0]._source.detected);
        commonDeviceIds.push({
            DeviceID: devidDataTemp['deviceid'],
            Beacon: devidDataTemp['Beaconid'],
            Detected: devidDataTemp['Detected']
        });
    });
  }

  const createCommonDeviceIdCsv = async () => {
    setIsLoading(true);

    try {
      // Beaconsを取得
      await getBeacons();

      // commonDeviceIdsのコピーを作成し、Beaconを変換
      const updatedDeviceIds = commonDeviceIds.map((item) => {
          return {
              ...item,
              Beacon: beaconIdToBeaconName(item.Beacon), // Beaconを変換
          };
      });

      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("CommonDeviceid");
      const worksheet = workbook.getWorksheet("CommonDeviceid");
      const columns: Partial<ExcelJS.Column>[] = [];
      columns.push({ header: "DeviceID", key: "DeviceID" })
      columns.push({ header: "Beacon", key: "Beacon" })
      columns.push({ header: "Detected", key: "Detected" })
    
      worksheet!.columns = columns;
      updatedDeviceIds.forEach((el => {
          worksheet!.addRow(el)
      }))
    
    
      const uint8Array = await workbook.csv.writeBuffer();
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom,uint8Array], { type: 'application/octet-binary' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      setTimeout(()=> {
          a.href = url;
          a.download = "CommonDeviceid_" + getNowDate() +  ".csv";
          a.click();
          a.remove();
      },1000)
    
    } catch (error) {
        console.error(error);
    }
    setIsLoading(false);

  }

  const getPastAndFutureDataByDevicesAnd1sec = async (e: any) => {
    setIsLoading(true);
    
    try {
      await getBeacons()
    } catch {
      alert("エラーが発生しました。")
      setIsLoading(false);
      return
    }

    // 取得用の一時マップ（deviceid+Detected をキーに before/after を紐付ける）
    const pairsMap: Map<string, { before: string; after: string; deviceid: string; detected: string }> = new Map();
    
    //取得したDeviceの指定時間の前後10件分のビーコンログを取得する
    const usedBeaforeIndexes = new Set<string>();

    for (let i = 0; i < commonDeviceIds.length; i++) {
      const devid = commonDeviceIds[i].DeviceID;
      const detected = commonDeviceIds[i].Detected;
      try {
        await getBeforeBeaconLogForDeviceID1Sec(devid, "desc", commonDeviceIds[i].Beacon, detected);
        // records1secMapから直接取得して決定的に処理
        const lookupKey = devid + '|' + detected;
        const rec = records1secMap.get(lookupKey);
        if (rec && !usedBeaforeIndexes.has(devid + '-' + detected)) {
          let lastValue = "";
          for (let idx = parseInt(numberoflogs); idx >= 1; idx--) {
            if (rec['beforeBeaconid' + idx]) {
              lastValue = rec['beforeBeaconid' + idx];
              break;
            }
          }
          if (lastValue) {
            const mapKey = rec.deviceid + '|' + rec.baseDetected;
            const prev = pairsMap.get(mapKey) || { before: '', after: '', deviceid: rec.deviceid, detected: rec.baseDetected };
            prev.before = lastValue;
            pairsMap.set(mapKey, prev);
            // deviceid-Detectedの組み合わせでスキップ管理
            usedBeaforeIndexes.add(rec.deviceid + '-' + rec.baseDetected);
          }
        }
      } catch (err) {
        console.error(`エラー at index ${i}:`, err);
        alert("エラーが発生しました。");
        setIsLoading(false);
        return;
      }
    }
  
    const usedAfterIndexes = new Set<string>();
    for (let i = 0; i < commonDeviceIds.length; i++) {
      const devid = commonDeviceIds[i].DeviceID;
      const detected = commonDeviceIds[i].Detected;
      try {
        await getAfterBeaconLogForDeviceID1Sec(devid, "asc", get1SecAfterTime(detected), detected);
        // records1secMapから直接取得して決定的に処理
        const lookupKeyA = devid + '|' + detected;
        const recA = records1secMap.get(lookupKeyA);
        if (recA) {
          let last = "";
          for (let idx = parseInt(numberoflogs); idx >= 1; idx--) {
            if (recA['afterBeaconid' + idx]) {
              last = recA['afterBeaconid' + idx];
              break;
            }
          }
          if (last) {
            const mapKey = recA.deviceid + '|' + recA.baseDetected;
            const prev = pairsMap.get(mapKey) || { before: '', after: '', deviceid: recA.deviceid, detected: recA.baseDetected };
            prev.after = last;
            pairsMap.set(mapKey, prev);
          }
          // deviceid-Detectedの組み合わせでスキップ管理
          usedAfterIndexes.add(recA.deviceid + '-' + recA.baseDetected);
        }
      } catch (err) {
        console.error(`エラー at index ${i}:`, err);
        alert("エラーが発生しました。");
        setIsLoading(false);
        return;
      }
    }

    // テーブルの除外フィルタを詳細CSV/前後ランキング出力にも適用
    const tokens = (filterText || '')
      .split(',')
      .map(t => t.trim().toLowerCase())
      .filter(Boolean);

    const maxLogs = parseInt(numberoflogs, 10);
    // commonDeviceIds の順に Map からレコードを取り出して安定順序の配列を作る
    const orderedRecords = commonDeviceIds.map(item => {
      const key = item.DeviceID + '|' + item.Detected;
      return records1secMap.get(key) || {
        deviceid: item.DeviceID,
        baseBeaconid: beaconIdToBeaconName(item.Beacon),
        baseDetected: item.Detected
      };
    });
    const filteredRecords1sec = tokens.length > 0
      ? orderedRecords.map((row) => {
          const nextRow: Record<string, any> = { ...row };

          const compactBeforeDisplayOrder: { beacon: string; detected: string }[] = [];
          const compactAfterDisplayOrder: { beacon: string; detected: string }[] = [];

          // before列は表示上「beforeN ... before1」の順なので、N→1で走査すると表示順になる
          for (let idx = maxLogs; idx >= 1; idx--) {
            const beforeKey = 'beforeBeaconid' + idx;
            const beforeDetectedKey = 'beforeDetected' + idx;
            const beforeNameRaw = String(nextRow[beforeKey] || '');
            const beforeNameLower = beforeNameRaw.toLowerCase();
            if (beforeNameRaw && !tokens.some(token => beforeNameLower.includes(token))) {
              compactBeforeDisplayOrder.push({
                beacon: beforeNameRaw,
                detected: String(nextRow[beforeDetectedKey] || ''),
              });
            }
          }

          // after列は表示上「after1 ... afterN」の順なので、1→Nで走査すると表示順になる
          for (let idx = 1; idx <= maxLogs; idx++) {
            const afterKey = 'afterBeaconid' + idx;
            const afterDetectedKey = 'afterDetected' + idx;
            const afterNameRaw = String(nextRow[afterKey] || '');
            const afterNameLower = afterNameRaw.toLowerCase();
            if (afterNameRaw && !tokens.some(token => afterNameLower.includes(token))) {
              compactAfterDisplayOrder.push({
                beacon: afterNameRaw,
                detected: String(nextRow[afterDetectedKey] || ''),
              });
            }
          }

          // 一旦クリア
          for (let idx = 1; idx <= maxLogs; idx++) {
            nextRow['beforeBeaconid' + idx] = '';
            nextRow['beforeDetected' + idx] = '';
            nextRow['afterBeaconid' + idx] = '';
            nextRow['afterDetected' + idx] = '';
          }

          // BeforeはBaseに対して右詰め（表示順で右寄せ）
          const beforeStartPos = maxLogs - compactBeforeDisplayOrder.length;
          for (let pos = 0; pos < compactBeforeDisplayOrder.length; pos++) {
            const displayPos = beforeStartPos + pos; // 0-based, 表示順の位置
            const targetIdx = maxLogs - displayPos; // 表示順(beforeN..before1) -> キー番号
            nextRow['beforeBeaconid' + targetIdx] = compactBeforeDisplayOrder[pos].beacon;
            nextRow['beforeDetected' + targetIdx] = compactBeforeDisplayOrder[pos].detected;
          }

          // AfterはBaseに対して左詰め（表示順で左寄せ）
          for (let pos = 0; pos < compactAfterDisplayOrder.length; pos++) {
            const targetIdx = pos + 1;
            nextRow['afterBeaconid' + targetIdx] = compactAfterDisplayOrder[pos].beacon;
            nextRow['afterDetected' + targetIdx] = compactAfterDisplayOrder[pos].detected;
          }

          return nextRow;
        })
      : orderedRecords;
  
    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("PastAndFutureDevice1sec");
    const worksheet = workbook.getWorksheet("PastAndFutureDevice1sec");
    const columns: Partial<ExcelJS.Column>[] = [];
    for (var idx = 1; idx <= parseInt(numberoflogs, 10); idx++) {
      if (idx == 1) {
        columns.push({ header: "DeviceID", key: "deviceid" })
        columns.push({ header: "beforeBeacon" + numberoflogs, key: "beforeBeaconid" + numberoflogs })
        columns.push({ header: "beforeDetected" + numberoflogs, key: "beforeDetected" + numberoflogs })
      } else {
        columns.push({ header: "beforeBeacon" + (parseInt(numberoflogs) - (idx - 1)), key: "beforeBeaconid" + (parseInt(numberoflogs) - (idx - 1)) })
        columns.push({ header: "beforeDetected" + (parseInt(numberoflogs) - (idx - 1)), key: "beforeDetected" + (parseInt(numberoflogs) - (idx - 1)) })
      }
    }
    columns.push({ header: "BaseBeacon", key: "baseBeaconid" })
    columns.push({ header: "BaseDetected", key: "baseDetected" })
  
    for (var idx = 1; idx <= parseInt(numberoflogs, 10); idx++) {
      columns.push({ header: "afterBeacon" + idx, key: "afterBeaconid" + idx })
      columns.push({ header: "afterDetected" + idx, key: "afterDetected" + idx })
    }
  
    worksheet!.columns = columns;
  
    // 出力順を安定化するためにソートしてから出力する
    filteredRecords1sec.sort((a, b) => {
      const aDev = String(a.deviceid || '');
      const bDev = String(b.deviceid || '');
      if (aDev !== bDev) return aDev.localeCompare(bDev);
      const aDet = String(a.baseDetected || '');
      const bDet = String(b.baseDetected || '');
      return aDet.localeCompare(bDet);
    });

    filteredRecords1sec.forEach((el => {
      worksheet!.addRow(el)
    }))

    
    try {  
      const uint8Array = await workbook.csv.writeBuffer();
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom,uint8Array], { type: 'application/octet-binary' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      setTimeout(()=> {
          a.href = url;
          a.download = "PastAndFutureDevice1sec_" + getNowDate() +  ".csv";
          a.click();
          a.remove();
      },1000)
    } catch (error) {
      console.error(error);
    }
    // ランキング入力用の行ペアを作成し、安定ソートする
    // pairsMapの値を配列化してペアを作成（まず全ペアを保持）
    let allPairs: { before: string; after: string }[] = Array.from(pairsMap.values()).map(v => ({ before: v.before || '', after: v.after || '' }));

    allPairs.sort((p1, p2) => {
      const k1 = (p1.before || '') + '|' + (p1.after || '');
      const k2 = (p2.before || '') + '|' + (p2.after || '');
      return k1.localeCompare(k2);
    });

    // フィルタ適用前の未フィルタ配列（ランキング集計はこれを使用する）
    const allBeforeBeacons = allPairs.map(p => p.before);
    const allAfterBeacons = allPairs.map(p => p.after);

    // 前後ランキングExcel出力（内部カウントは未フィルタ配列を使用し、出力行はフィルタで除外）
    await exportPastAndFutureBeaconRankingExcel(allBeforeBeacons, allAfterBeacons, tokens);
    setIsLoading(false);
  }

  const getBeforeBeaconLogForDeviceID1Sec = async (serachDeviceid: string, searchSort: string, searchBeaconId: string, searchLte: string) => {
    try {
      // deviceDetectedDayTypeに応じてsearchLteを調整
      let useSearchLte = searchLte;
      if (deviceDetectedDayType === 'plus1') {
        const dt = new Date(searchLte);
        dt.setDate(dt.getDate() - 1);
        useSearchLte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus2') {
        const dt = new Date(searchLte);
        dt.setDate(dt.getDate() - 2);
        useSearchLte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus3') {
        const dt = new Date(searchLte);
        dt.setDate(dt.getDate() - 3);
        useSearchLte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus4') {
        const dt = new Date(searchLte);
        dt.setDate(dt.getDate() - 4);
        useSearchLte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus5') {
        const dt = new Date(searchLte);
        dt.setDate(dt.getDate() - 5);
        useSearchLte = dt.toISOString().slice(0, 19).replace('T', ' ');
      }
      // 当日の場合はsearchLteそのまま
    
      // パラメータを動的に作成
      const params: any = {
        device_id: [serachDeviceid],
        per_page: 1000,
        ...(searchLte ? { detected_lt: get1SecBeforeTime(searchLte).replace("T", " ") } : {}),
        sort: searchSort
      };
      
      let dateStr = useSearchLte.split("T")[0].split(" ")[0];
      dateStr = dateStr + " 00:00:00";
      params.detected_gt = dateStr;
    
      const res = await axios.get(apiUrl, {
        headers: {
          "Authorization": props.apikey,
          "Content-Type": "application/json"
        },
        params
      });

      if (res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
          throw new Error("条件設定に問題があります。");
      } else if (res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
          throw new Error("APIKeyが正しく入力されていません。");
      }
  
      const items = JSON.parse(JSON.stringify(res.data.payload));
      // 安定化: API応答の data 配列を明示的にソートして決定性を保証
      if (items && Array.isArray(items.data)) {
        items.data.sort((a: any, b: any) => {
          const ta = new Date(a.detected).getTime();
          const tb = new Date(b.detected).getTime();
          if (searchSort === 'desc') {
            if (tb !== ta) return tb - ta;
          } else {
            if (ta !== tb) return ta - tb;
          }
          // タイブレーカー: beacon_id を文字列比較
          const ba = String(a.beacon_id || '');
          const bb = String(b.beacon_id || '');
          return ba.localeCompare(bb);
        });
      }
      let logHistorytemp: Record<string, any> = {
        deviceid: serachDeviceid,
        baseBeaconid: beaconIdToBeaconName(searchBeaconId),
        baseDetected: searchLte,
      };
      let lastDetectedUnix: number | null = null;
      let count = 0;
      const maxLogs = parseInt(numberoflogs);

      if (items.data.length >= 1) {
        // detectedの降順で1分おきに最大maxLogs件格納
        items.data.forEach((value: beaconResultType, index: number) => {
          const detectedUnix = new Date(value.detected).getTime();
          if (
            count === 0 || // 最初は必ず格納
            (lastDetectedUnix !== null && detectedUnix <= lastDetectedUnix - getSectoMillisecond(intervaloflogs)) // 1分おきに格納
          ) {
            logHistorytemp['beforeBeaconid' + (count + 1)] = beaconIdToBeaconName(value.beacon_id);
            logHistorytemp['beforeDetected' + (count + 1)] = value.detected;
            lastDetectedUnix = detectedUnix;
            count++;
          }
          if (count >= maxLogs) return; // 上限に達したら終了
        });
        // Map に格納（key は deviceid|detected）
        records1secMap.set(serachDeviceid + '|' + searchLte, logHistorytemp);
      } else {
        records1secMap.set(serachDeviceid + '|' + searchLte, logHistorytemp);
      }
  
      return Promise.resolve();
    } catch (err: any) {
        alert("エラーが発生しました。" + (err as any).message);
        return Promise.reject(err);
    }
  }

  // 前後ランキングExcel出力用関数
  const exportPastAndFutureBeaconRankingExcel = async (beforeBeacons: string[], afterBeacons: string[], tokens: string[] = []) => {
    // 集計（カウントはフィルタを適用せずそのまま集計する）
    const countArray = (arr: string[]) => {
      const count: { [key: string]: number } = {};
      arr.forEach(name => {
        if (!name) return;
        count[name] = (count[name] || 0) + 1;
      });
      return Object.entries(count).map(([BeaconName, count]) => ({ BeaconName, count }));
    };

    const beforeRanking = countArray(beforeBeacons).sort((a, b) => b.count - a.count);
    const afterRanking = countArray(afterBeacons).sort((a, b) => b.count - a.count);

    // Excel出力
    const workbook = new ExcelJS.Workbook();
    const wsBefore = workbook.addWorksheet("PastRanking");
    wsBefore.columns = [
      { header: "No", key: "index" },
      { header: "BeaconName", key: "BeaconName" },
      { header: "count", key: "count" }
    ];
    // 出力時はtokensに一致するビーコンを行として出力しない（ただし内部カウントは保持）
    let outIdxBefore = 1;
    beforeRanking.forEach((row) => {
      if (tokens.length > 0 && String(row.BeaconName).toLowerCase().split(',').length >= 0) {
        const lower = String(row.BeaconName).toLowerCase();
        if (tokens.some(t => lower.includes(t))) return;
      }
      wsBefore.addRow({ index: outIdxBefore++, ...row });
    });

    const wsAfter = workbook.addWorksheet("FutureRanking");
    wsAfter.columns = [
      { header: "No", key: "index" },
      { header: "BeaconName", key: "BeaconName" },
      { header: "count", key: "count" }
    ];
    let outIdxAfter = 1;
    afterRanking.forEach((row) => {
      if (tokens.length > 0) {
        const lower = String(row.BeaconName).toLowerCase();
        if (tokens.some(t => lower.includes(t))) return;
      }
      wsAfter.addRow({ index: outIdxAfter++, ...row });
    });

    try {
      const uint8Array = await workbook.xlsx.writeBuffer();
      const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      setTimeout(() => {
        a.href = url;
        a.download = "PastAndFutureBeaconRanking_" + getNowDate() + ".xlsx";
        a.click();
        a.remove();
      }, 1000);
    } catch (error) {
      console.error(error);
      alert("Excel出力時にエラーが発生しました。");
    }
  };
  
  const getAfterBeaconLogForDeviceID1Sec = async (serachDeviceid: string, searchSort: string, searchGte: string, searchBaseDetected: string) => {
    try {
      let useSearchGte = searchGte;
      if (deviceDetectedDayType === 'plus1') {
        const dt = new Date(searchGte);
        dt.setDate(dt.getDate() + 1);
        useSearchGte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus2') {
        const dt = new Date(searchGte);
        dt.setDate(dt.getDate() + 2);
        useSearchGte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus3') {
        const dt = new Date(searchGte);
        dt.setDate(dt.getDate() + 3);
        useSearchGte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus4') {
        const dt = new Date(searchGte);
        dt.setDate(dt.getDate() + 4);
        useSearchGte = dt.toISOString().slice(0, 19).replace('T', ' ');
      } else if (deviceDetectedDayType === 'plus5') {
        const dt = new Date(searchGte);
        dt.setDate(dt.getDate() + 5);
        useSearchGte = dt.toISOString().slice(0, 19).replace('T', ' ');
      }
      // 当日の場合はsearchGteそのまま

      // パラメータを動的に作成
      const params: any = {
        device_id: [serachDeviceid],
        per_page: 1000,
        ...(searchGte ? { detected_gt: searchGte.replace("T", " ") } : {}),
        sort: searchSort
      };
      
      let dateStr = useSearchGte.split("T")[0].split(" ")[0];
      dateStr = dateStr + " 23:59:59";
      params.detected_lt = dateStr;
    
      const res = await axios.get(apiUrl, {
        headers: {
          "Authorization": props.apikey,
          "Content-Type": "application/json"
        },
        params
      });

      if (res.data.code === 400) {
        alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
        throw new Error("条件設定に問題があります。");
      } else if (res.data.code === 401) {
        alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
        throw new Error("APIKeyが正しく入力されていません。");
      }

      const items = JSON.parse(JSON.stringify(res.data.payload));
      // 安定化: API応答の data 配列を明示的にソートして決定性を保証
      if (items && Array.isArray(items.data)) {
        items.data.sort((a: any, b: any) => {
          const ta = new Date(a.detected).getTime();
          const tb = new Date(b.detected).getTime();
          if (searchSort === 'asc') {
            if (ta !== tb) return ta - tb;
          } else {
            if (tb !== ta) return tb - ta;
          }
          const ba = String(a.beacon_id || '');
          const bb = String(b.beacon_id || '');
          return ba.localeCompare(bb);
        });
      }
      let lastDetectedUnix: number | null = null;
      let count = 0;
      const maxLogs = parseInt(numberoflogs);

      // records1secMapの該当デバイスを取得
      const recordKey = serachDeviceid + '|' + searchBaseDetected;
      const record = records1secMap.get(recordKey);
      if (!record) return;

      for (const value of items.data as beaconResultType[]) {
        const detectedUnix = new Date(value.detected).getTime();
        if (
          count === 0 || // 最初は必ず格納
          (lastDetectedUnix !== null && detectedUnix >= lastDetectedUnix + getSectoMillisecond(intervaloflogs))
        ) {
          record['afterBeaconid' + (count + 1)] = beaconIdToBeaconName(value.beacon_id);
          record['afterDetected' + (count + 1)] = value.detected;
          lastDetectedUnix = detectedUnix;
          count++;
        }
        if (count >= maxLogs) return;
      };

      return Promise.resolve();
    } catch (err) {
      alert("エラーが発生しました。" + (err as any).message);
      return Promise.reject(err);
    }
  }
  

  const beaconIdToBeaconName = (beaconid: string) => {
      
      var ret = beaconid

      beaconResults.forEach((beaconValue: BeaconModel) => {
          if (beaconid == beaconValue.id) {
              ret = beaconValue.name;
              return
          }
      })
      return ret
  }

  const getBeacons = async() => {
    try {
        const res = await axios.get(beaconApiUrl, {
            headers: {
                "Authorization": props.apikey,
                "Content-Type": "application/json"
            },
            params: {
                per_page: 1000
            }
        });
        console.log(res);
        if (res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload));
            return;
        } else if (res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message));
            return;
        }
        const items = res.data.payload;
        console.log(items);

        items.data.forEach((value: BeaconModel) => {
            beaconResults.push(value);
        });

        return Promise.resolve();
    } catch (err) {
        alert("エラーが発生しました。" + (err as any).message);
        return Promise.reject(err);
    }
  };

  const get1SecBeforeTime = (time: string) => {
    let dt = new Date(time)
    let before1min_unix = dt.getTime() - 1000
    let before1min = new Date(before1min_unix)
    let y = before1min.getFullYear();
    let m = ("00" + (before1min.getMonth()+1)).slice(-2);
    let d = ("00" + (before1min.getDate())).slice(-2);
    let hour = ("00" + (before1min.getHours())).slice(-2);
    let min = ("00" + (before1min.getMinutes())).slice(-2);
    let sec = ("00" + (before1min.getSeconds())).slice(-2);

    let result = y + "-" + m + "-" + d + " " + hour + ":" + min + ":" + sec

    //console.log(result)
    return result
  }

  const get1SecAfterTime = (time: string) => {
    let dt = new Date(time)
    let before1min_unix = dt.getTime() + 1000
    let before1min = new Date(before1min_unix)
    let y = before1min.getFullYear();
    let m = ("00" + (before1min.getMonth()+1)).slice(-2);
    let d = ("00" + (before1min.getDate())).slice(-2);
    let hour = ("00" + (before1min.getHours())).slice(-2);
    let min = ("00" + (before1min.getMinutes())).slice(-2);
    let sec = ("00" + (before1min.getSeconds())).slice(-2);

    let result = y + "-" + m + "-" + d + " " + hour + ":" + min + ":" + sec

    //console.log(result)
    return result
  }

  const changeNumberOfLogs = (value: string) => {
    setNumberOfLogs(value);
  }

  const changeIntervalOfLogs = (value: string) => {
    setIntervalOfLogs(value);
  }

  const clearAllSelections = () => {
    table.resetRowSelection();
  };

  useEffect(() => {
    setBundle_id_ios(props.bundle_ids[0])
    setBundle_id_and(props.bundle_ids[1])
    setBundle_id_gate(props.bundle_ids[2])
  },[])

  useEffect(() => {
    table.resetRowSelection();
  }, [data]);
  

  const changeDetectedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    value.replace("T", " ");
    setDetcted_gt(value);
  }

  const changeDetectedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) {
      value = value + ":00";
    }
    value.replace("T", " ");
    setDetcted_lt(value);
  }

  const getSectoMillisecond = (value: string) => {
    return Number(value) * 1000;
  }



  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    let result = y  + m +  d;
    return result;
  }

  const unixdateformat = (str : string) => {
    const timestamp = parseInt(str, 10) * 1000;
    var objDate = new Date(timestamp);
    var nowDate = new Date();
    //現在時間との差
    let myHour = Math.floor((nowDate.getTime()-objDate.getTime()) / (1000*60*60)) + 1;
    var year = objDate.getFullYear();
    var month = (objDate.getMonth() + 1).toString();
    if ( month.length < 2 ) { month = "0" + month; }
    var date = objDate.getDate().toString();
    if (date.length < 2) { date = "0" + date; }
    var hours = objDate.getHours();
    var minutes = objDate.getMinutes().toString();
    var seconds = objDate.getSeconds().toString();
    if ( minutes.length < 2 ) { minutes = "0" + minutes; }
    if ( hours < 10 ) { hours = Number("0" + hours); }
    if ( minutes.length < 2 ) { minutes = "0" + minutes; }
    if ( seconds.length < 2 ) { seconds = "0" + seconds; }
    str = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
    var rtnValue = str;

    return rtnValue;
  }



  function IndeterminateCheckbox({
      indeterminate,
      className = '',
      ...rest
    }: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
      const ref = React.useRef<HTMLInputElement>(null!)
    
      React.useEffect(() => {
        if (typeof indeterminate === 'boolean') {
          ref.current.indeterminate = !rest.checked && indeterminate
        }
      }, [ref, indeterminate])
    
      return (
        <input
          type="checkbox"
          ref={ref}
          className={className + ' cursor-pointer'}
          {...rest}
        />
      )
    }

  return (
      
    <div>
      <Form className="font-weight-bold">
        <Form.Group as={Row} className="mx-3">
          <Col xs={12} md={4}>
            <Form.Label>軸となるBeacon一覧</Form.Label>
            <Form.Control as="textarea" rows={3} name="basebeacons" disabled value={basebeaconNameArrays.join(",\n")} className="w-27" />
            <Form.Group as={Button} type="button" variant="warning" className="mt-3 mb-2 mr-2" onClick={(e) =>  getBaseBeaconIdArray(e)}>軸となるBeaconを設定</Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>対象とするBeacon一覧</Form.Label>
            <Form.Control as="textarea" rows={3} name="subjectbeacons" disabled value={subjectbeaconNameArrays.join(",\n")} className="w-27" />
            <Form.Group as={Button} type="button" variant="warning" className="mt-3 mb-2 mr-2" onClick={(e) =>  getSubjectBaseBeaconIdArray(e)}>対象とするBeaconを設定</Form.Group>
          </Col>
        </Form.Group>
        
        <Form.Group as={Row} className="mx-3">
          <Col xs={12} md={4}>
            <Form.Label>BundleID(iOS)</Form.Label>
            <Form.Control type="text" name="uuid" disabled value={bundle_id_ios as string} className="w-27" onChange={(e) => setBundle_id_ios(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>BundleID(Android)</Form.Label>
            <Form.Control type="text" name="uuid" disabled value={bundle_id_and as string} className="w-27" onChange={(e) => setBundle_id_and(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>BundleID(GateWay)</Form.Label>
            <Form.Control type="text" name="uuid" disabled value={bundle_id_gate as string} className="w-27" onChange={(e) => setBundle_id_gate(e.target.value)} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mx-3">

          <Col xs={12} md={4}>
            <Form.Label>Detected_gt（ビーコン発見時刻以降）</Form.Label>
            <Form.Control type="datetime-local" step="1" autoComplete="on" name="detected_gt" value={detected_gt as string} className="w-27" placeholder="ビーコン発見時の時刻（>=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedGt(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>Detected_lt（ビーコン発見時刻以前）</Form.Label>
            <Form.Control type="datetime-local" step="1" name="detected_lt" value={detected_lt as string} className="w-27" placeholder="ビーコン発見時の時刻（<=）を入力 [YYYY-mm-dd hh:mm:ss]" onChange={(e) => changeDetectedLt(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>前後ビーコン接触件数（過去と未来のビーコンログ件数）</Form.Label>
            <Form.Control type="text" name="numberoflogs" value={numberoflogs as string} className="w-27" placeholder="出力する前後のビーコン接触件数を入力" onChange={(e) => changeNumberOfLogs(e.target.value)} />
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>前後ビーコン間隔（秒）</Form.Label>
            <Form.Control type="text" name="numberofinterval" value={intervaloflogs as string} className="w-27" placeholder="出力する前後のビーコン間隔（秒）を入力" onChange={(e) => changeIntervalOfLogs(e.target.value)} />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mx-3">
          <Col xs={12} md={4}>
            <Form.Label>テーブル除外フィルタ（部分一致で除外）</Form.Label>
            <Form.Control
              type="text"
              placeholder="除外する文字列をカンマ区切りで入力"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </Col>
        </Form.Group>
        
       
        <div className="d-flex flex-column align-items-center" style={{ width: '100%' }}>
        <Button type="button" variant="primary"  style={{ width: 400, marginBottom: 8 }}className="mt-3 mb-2 mr-2" onClick={(e) =>  getSpecifiedTimeAndBeaconIdsUniqueDevice(e, "devices")}>両方のBeaconを取得するデバイスIDを取得（CSV）</Button>
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-ranking">
              ビーコン群A・B両方を取得していたデバイスが、指定した時間で取得したビーコンのランキングをCSVで取得します。<br></br>
            </Tooltip>
          }
        >
          <span className="d-inline-block">
            <Button type="button" variant="success"  style={{ width: 400, marginBottom: 8 }} className="mt-3 mb-2 mr-2" onClick={(e) =>  getSpecifiedTimeAndBeaconIdsUniqueDevice(e, "ranking")}>ビーコン受信数ランキングを取得（CSV）</Button>
          </span>
        </OverlayTrigger>
        </div>
        <div className="text-center">
          <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-ranking">
              ビーコン群A・B両方を取得していたデバイスの、前後n件の最後尾（過去）または最前列（未来）のビーコンのランキングをCSVで取得します。<br></br>
            </Tooltip>
          }
        >
          <Button type="button" variant="info"  style={{ width: 400, marginBottom: 8 }} className="mt-3 mb-2 mr-2" onClick={(e) =>  getSpecifiedTimeAndBeaconIdsUniqueDevice(e, "beacons")}>デバイスID毎の前後n件のビーコン接触情報を取得（CSV）</Button>
        </OverlayTrigger>
            <div className='text-center'>
            <Form.Control as="select"
              className="mb-2"
              value={deviceDetectedDayType}
              onChange={e => setDeviceDetectedDayType(e.target.value as 'today' | 'plus1' | 'plus2' | 'plus3' | 'plus4' | 'plus5')}
              style={{ maxWidth: 400, margin: '0 auto' }}
            >
              <option value="today">当日</option>
              <option value="plus1">当日+前後1日（2日間）</option>
              <option value="plus2">当日+前後2日（3日間）</option>
              <option value="plus3">当日+前後3日（4日間）</option>
              <option value="plus4">当日+前後4日（5日間）</option>
              <option value="plus5">当日+前後5日（6日間）</option>
            </Form.Control>
            </div>
        </div>
      </Form>
    
      <p className='mx-3'>項目の表示・非表示</p>
      <div id='colVisible' className="px-1 mx-3">
          {table.getAllLeafColumns().map(column => {
          return (
          <label className='mx-3'>

              <input
                  checked={column.getIsVisible()}
                  onChange={column.getToggleVisibilityHandler()}
                  type="checkbox"
              />{' '}
              {column.id}
          </label>
          )
          })}
      </div>
      <div className='dataScroll'>
          <table>
              <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                      {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                      </th>
                  ))}
                  </tr>
              ))}
              </thead>
              <tbody>
              {table.getRowModel().rows.map((row) => (
                  <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                      <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                  ))}
                  </tr>
              ))}
              </tbody>
          </table>
      </div>
      {(() => {
      if (isLoading) {
        return (
          <div>
            <Loading/>
          </div>
        )
      }
      })()}
    </div>      
  )
}

export default BeaconMasterResultCommonDevice